import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { currency } from 'utils/utils'
import { Grid, Box, Typography } from '@material-ui/core'
import { isEmpty } from 'lodash'

import useStyles from './style'
import { financialAgreementDataSelector, isLoadingFinancialAgreementSelector } from 'modules/Negotiation/Finance/selectors/financialAgreement'
import { FormattedMessage, injectIntl } from 'react-intl'
import Message from '../message'
import Loading from 'components/loading'

import { useRecoilState } from "recoil";
import * as _blackListService from '../../../../../../service/blacklist-service'
import {unidadeGetResponseState} from "../../../../../../recoil/atoms/unidadeGetResponseState";
import blockedResourcesSystem from '../../../../../../utils/blockedResourcesSystem';
import { blockedResourcesEntitiesValues } from '../../../../../../utils/blockedResourcesEntities'

export default injectIntl((props) => {
  const classes = useStyles()
  const {  intl: { messages } ,setDisabled, items } = props
  const financialAgreement = useSelector(financialAgreementDataSelector)
  const isLoadingFinancialAgreement = useSelector(isLoadingFinancialAgreementSelector)
  const numberInstallment = items.length >= 4 ? 10 : (items.length * 2)

  const total = financialAgreement && financialAgreement.list && financialAgreement.list.reduce((prev, curr) => prev + Number(curr.amountCur), 0)
  
  const [viewLock, setViewLock] = useState({})
  const [unidade, setUnidade] = useRecoilState(unidadeGetResponseState)
  const [blockedResources, setBlockedResources] = useState([])
  const [isLoadingBlockedResources, setIsLoadingBlockedResources] = useState(true)

  useEffect(() => {
    setDisabled(false)
  })
  
  useEffect(() => {
    if (unidade && blockedResources && blockedResources.length) {
      const {id: idUnidade} = unidade
      const locksFiltered = blockedResources.filter(r => r?.unidadeId === idUnidade && r.type === blockedResourcesEntitiesValues.Unidade)
      if (locksFiltered) {
        const verifylock = ({ lockName, action, setLock, defaultMessage, selectedYear }) => {
          const lockFound = locksFiltered.find(x => x.action.toLowerCase() === action.toLowerCase())
          if (lockFound) {
            setLock({
              [lockName]: true,
              [`${lockName}Message`]: lockFound?.mensagemBloqueio && lockFound?.mensagemBloqueio !== ''
                ? lockFound?.mensagemBloqueio
                : defaultMessage
            })
          } else {
            setLock({})
          }
        }

        verifylock({
          lockName: 'parcela',
          setLock: setViewLock,
          action: "AcordoParceladoPortal/Unidade",
          defaultMessage: 'Não permite parcelamento',
        })
      }
    }
  }, [unidade, blockedResources])
  
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      if (!blockedResources || !blockedResources.length) {
        await _blackListService.GetBySistemaId(blockedResourcesSystem.SMO).then((response) => {
          if (response && response.length) {
            setBlockedResources(response)
          }
          setIsLoadingBlockedResources(false)
        }).catch(() => {
          setIsLoadingBlockedResources(false)
        })
      }
    }
    fetchPaymentTypes();
  }, [])

  if(isLoadingFinancialAgreement) {
    return <Loading message={messages['finance-negotiation-comp-installment-form-loaging']} /> 
  }
  
  if(!financialAgreement || isEmpty(financialAgreement.financialAgreementId)  || total === 0) {
    setDisabled(true)
    return <Message title={messages['finance-negotiation-comp-installment-form-title-error']} message={messages['finance-negotiation-comp-installment-form-error']} />
  }

  return (
    <React.Fragment>
      <Grid container className={classes.billetFormContainer} alignContent='flex-start' >
        <Grid item xs={12} className={classes.billetFormItem} md={12} >
          <Typography className={classes.formAmount}>
            <FormattedMessage id='intallment-form-negotiation-proposal' />
          </Typography>
          <Typography className={classes.formValueAmount}>
            {currency(total)}
          </Typography>
        </Grid>
        {!viewLock?.parcela && financialAgreement.list && financialAgreement.list.length > 0 && <Grid item xs={12} className={classes.billetFormItem} >
          <Box classes={{
            root: classes.root
          }}>
            <FormattedMessage id='installment-form-negotiation' values={{ instalmments: numberInstallment }} />
          </Box>
        </Grid>}
      </Grid>
    </React.Fragment>
  )
})
